import _typeof from "@babel/runtime/helpers/typeof";
import { applyMiddleware, createStore, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import thunkMiddleware from 'redux-thunk'; // TODO: using due to add-to-trolley. group decision on how to handle middleware going forward

import rootReducer from '../redux';
import { actionPasser } from '../redux/mergeState'; // Checking if createSagaMiddleware is a function and falling back to default
// prevents sagas from nuking apps that include sagas and loads Redux from commonvendor

var sagaMiddleware = typeof createSagaMiddleware === 'function' ? createSagaMiddleware() : createSagaMiddleware.default();

var enhancer = function enhancer(dispatcher) {
  if (process.env.NODE_ENV === 'development') {
    return compose(applyMiddleware(sagaMiddleware, thunkMiddleware, actionPasser(dispatcher)), (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined' // eslint-disable-line no-underscore-dangle
    ? window.__REDUX_DEVTOOLS_EXTENSION__() // eslint-disable-line no-underscore-dangle
    : function (func) {
      return func;
    });
  }

  return compose(applyMiddleware(sagaMiddleware, thunkMiddleware, actionPasser(dispatcher)));
};

export default function configureStore(dispatcher) {
  var store = createStore(rootReducer, enhancer(dispatcher));
  store.runSaga = sagaMiddleware.run;
  return store;
}